module.exports = __webpack_public_path__ + "static/media/Prologis.fef0e79b.png";